import React from "react";
import Meaning from "./Meaning";
import "./Dictionary.css";

export default function Results(props) {
  if (props.results) {
    return (
      <div className="Results">
        <section>
          <h2 className="text-capitalize">{props.results.word}</h2>
          {props.results.phonetic}
        </section>
        <div className="row">
          {props.results.meanings.map(function (meaning, index) {
            return (
              <div className="col-6" key={index}>
                <Meaning meaning={meaning} />
              </div>
            );
          })}
        </div>
      </div>
    );
  } else {
    return null;
  }
}
